/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { TicketPagedList } from '../../models/ticket-paged-list';
import { TicketSearchBody } from '../../models/ticket-search-body';
import { TicketSortFieldName } from '../../models/ticket-sort-field-name';

export interface SearchStationTickets$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NUMBER_TICKET : the number ticket
 *   * CREATION_DATE : the ticket creation date
 *   * LAST_UPDATE : the ticket last update date
 *   * STATION_NAME : the station name
 *   * TYPE_PANNE : type panne
 *   * STATE : the state
 */
  sortFieldName?: TicketSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * Search in historical states of ticket
 */
  historicalState?: boolean;
  
    /**
     * Body for search ticket
     */
    body?: TicketSearchBody
}

export function searchStationTickets$Json(http: HttpClient, rootUrl: string, params: SearchStationTickets$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchStationTickets$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('historicalState', params.historicalState, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketPagedList>;
    })
  );
}

searchStationTickets$Json.PATH = '/stations/{uid}/tickets/search';
